<template>
  <div>
    <form
      @submit.prevent="handleKbSearchEntered"
    >
      <InputSearch
        v-model="searchTerm"
        placeholder="Search"
      />
    </form>
  </div>
</template>
<script>
import {
  InputSearch,
} from '@jumpcloud/ui-components';
import { UiEvents } from '@jumpcloud/ui-events-vue';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import Util from 'client/util/Util';

export default {
  name: 'KnowledgeBaseSearch',

  EventHelper,
  Util,

  components: {
    InputSearch,
  },
  props: {
    section: {
      type: String,
      default: 'KB search bar',
    },
  },

  data() {
    return {
      searchTerm: '',
    };
  },

  methods: {
    handleKbSearchEntered() {
      // e.g. 'OS' is the shortest meaningful value to search against
      if (this.searchTerm.length > 1) {
        const searchLink = `https://support.jumpcloud.com/s/global-search/${this.searchTerm}`;
        UiEvents.triggerInputEntered({
          description: `KB search bar input: ${this.searchTerm}`,
          page: this.$page,
          section: this.section,
          value: this.searchTerm,
          text: 'Have questions? Search our knowledge base',
          toUrl: searchLink,
        });
        this.$options.Util.openUrl(searchLink);
      }
    },
  },
};
</script>

<style module>
.container {
  border: var(--jc-border);
}
</style>
